export const TaskObjectDefaults = {
  Task: {
    Task_Status: 'New',
    Task_Status_Desc: 'Not Saved',
    Protect_Late_Ind: 'N',
    Task_Required_Ind: 'N',
    Note_Required_Ind: 'N',
    Priority: '2'
  }
};
